import graphql from "babel-plugin-relay/macro";
import { useMutation } from "react-relay";

import {
  CancelMemberPackageInput,
  useCancelMemberPackageMutation,
  useCancelMemberPackageMutation$data,
} from "./__generated__/useCancelMemberPackageMutation.graphql";

export const useCancelMemberPackage = () => {
  const [cancelMemberPackageMutation, isCancelling] =
    useMutation<useCancelMemberPackageMutation>(
      useCancelMemberPackageMutationString
    );

  const cancelMemberPackage = (
    input: CancelMemberPackageInput,
    onComplete?: (data: useCancelMemberPackageMutation$data) => void,
    onError?: (error: Error) => void
  ) => {
    cancelMemberPackageMutation({
      variables: { input },
      onCompleted: (res) => {
        if (res.cancelMemberPackage?.success) {
          onComplete && onComplete(res);
        } else {
          const error = new Error(
            res.cancelMemberPackage?.errors?.[0]?.code || "Unknown error"
          );
          if (onError) {
            onError(error);
          }
        }
      },
      onError: (error) => {
        if (onError) {
          onError(error);
        }
      },
    });
  };

  return [cancelMemberPackage, isCancelling] as const;
};

const useCancelMemberPackageMutationString = graphql`
  mutation useCancelMemberPackageMutation($input: CancelMemberPackageInput!) {
    cancelMemberPackage(input: $input) {
      memberPackage {
        cancelledOn
        endsOn
      }
      success
      errors {
        field
        code
      }
    }
  }
`;
